<script>
import SpinLoader from '@/components/SpinLoader'

export default {
    name: "SignUp",
    components: {SpinLoader},
    data() {
        return {
            checkboxReady: false,
            login: "",
            email: "",
            password: "",
            repeatPassword: "",
            isPasswordVisible: false,
            loading: false,
        }
    },
    methods: {
        onClickTelegram() {
            window.location.href = '/tg-redirect'
        },
        onClickDiscord() {
            window.location.href = `https://discord.com/oauth2/authorize?client_id=1346821210952171570&response_type=token&redirect_uri=https%3A%2F%2Fcloudmods.app%2Fdiscord-redirect&scope=identify+email+guilds.join`
        },
        onClickGoogle() {
            window.location.href = `/google-site`
        },
        onClickYandex() {
            window.location.href = 'https://oauth.yandex.ru/authorize?client_id=a3df9c7e53544b4a8d6a0a6116b73b59&response_type=token&redirect_uri=https%3A%2F%2Fcloudmods.app%2Fredirect-yandex&widget_kind=default&suggest_hostname=cloudmods.app'
        },
        isValidEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return regex.test(email)
        },
        goToAuth() {
            this.$router.push({ path: '/signin', query: this.$route.query })
        },
        togglePasswordVisibility() {
            this.isPasswordVisible = !this.isPasswordVisible
        },
        async submit() {
            if(this.loading) return

            try {

                if(!this.login.trim() || !this.password.trim() || !this.email.trim() || !this.repeatPassword.trim()) return alert('Заполните все поля!')

                if(!this.isValidEmail(this.email.trim())) {
                    return alert('Неверный email адрес!')
                }

                if(this.password !== this.repeatPassword) {
                    return alert('Пароли не совпадают!')
                }

                this.loading = true

                const response = await fetchServer('/signup', {
                    login: this.login,
                    email: this.email,
                    password: this.password,
                    service: 'landing',
                    ref: localStorage.getItem('ref')
                })

                if(response['err']) {
                    this.loading = false
                    alert(response['err'])
                    return
                }

                if(response['internalError'] || !response['sessionHash']) {
                    this.loading = false
                    alert('Что-то пошло не так! Попробуйте ещё раз позже')
                    return
                }

                localStorage.setItem('hash', response['sessionHash'])
                this.$router.push(this.$route?.query?.return_url || '/')

                this.loading = false
            } catch (e) {
                this.loading = false
                alert('Что-то пошло не так! Попробуйте ещё раз позже')
            }
        }
    },
    mounted() {
        // document.querySelector('input').focus()
    }
}
</script>

<template>
    <section class="sign">
        <div class="sign-box">
            <div class="sign-title">{{__('Регистрация')}}</div>
            <div class="sign-inputs-and-login-container">
                <div class="sign-all-container">
                    <div class="sign-inputs-container">
                        <div class="sign-container">
                            <div class="sign-container-title">{{__('Логин')}}</div>
                            <div class="sign-input-wrapper">
                                <input type="text" v-model="login" class="sign-input" placeholder="Введите логин" autocorrect="off" autocapitalize="off" spellcheck="false"/>
                            </div>
                        </div>
                        <div class="sign-container">
                            <div class="sign-container-title">{{__('Электронная почта')}}</div>
                            <div class="sign-input-wrapper">
                                <input type="email" v-model="email" class="sign-input" placeholder="Введите эл. почту" autocorrect="off" autocapitalize="off" spellcheck="false"/>
                            </div>
                        </div>
                        <div class="sign-container">
                            <div class="sign-container-title">{{ __('Пароль') }}</div>
                            <div class="sign-input-wrapper">
                                <input :type="isPasswordVisible ? 'text' : 'password'" v-model="password"
                                       class="sign-input" placeholder="Введите пароль" autocorrect="off"
                                       autocapitalize="off" spellcheck="false"/>
                                <svg v-if="!this.isPasswordVisible" class="visibleIcon"
                                     @click="togglePasswordVisibility" width="20" height="20" viewBox="0 0 20 20"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.32031 11.2577C1.82031 10.4989 1.82031 9.49997 2.32031 8.74108C3.45142 7.02664 5.94476 4.16553 10.0003 4.16553C14.0559 4.16553 16.5503 7.02553 17.6803 8.74108C18.1803 9.49997 18.1803 10.4989 17.6803 11.2577C16.5492 12.9722 14.0559 15.8333 10.0003 15.8333C5.94476 15.8333 3.45031 12.9733 2.32031 11.2577Z"
                                        stroke="#848484" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                    <path
                                        d="M9.99989 13.0554C11.6874 13.0554 13.0554 11.6874 13.0554 9.99989C13.0554 8.31235 11.6874 6.94434 9.99989 6.94434C8.31235 6.94434 6.94434 8.31235 6.94434 9.99989C6.94434 11.6874 8.31235 13.0554 9.99989 13.0554Z"
                                        stroke="#848484" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                </svg>
                                <svg v-if="this.isPasswordVisible" class="visibleIcon" @click="togglePasswordVisibility"
                                     width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.2708 11.1459L11.9792 9.85425C12.0347 9.32647 11.875 8.87161 11.5 8.48966C11.125 8.10772 10.6736 7.94453 10.1458 8.00008L8.85417 6.70841C9.03472 6.63897 9.22222 6.58689 9.41667 6.55216C9.61111 6.51744 9.80556 6.50008 10 6.50008C10.9722 6.50008 11.7986 6.84036 12.4792 7.52091C13.1597 8.20147 13.5 9.02786 13.5 10.0001C13.5 10.1945 13.4826 10.389 13.4479 10.5834C13.4132 10.7779 13.3542 10.9654 13.2708 11.1459ZM16.0417 13.9167L14.9583 12.8334C15.4583 12.4445 15.9132 12.0174 16.3229 11.5522C16.7326 11.0869 17.0764 10.5695 17.3542 10.0001C16.6736 8.5973 15.6701 7.49661 14.3438 6.698C13.0174 5.89939 11.5694 5.50008 10 5.50008C9.63889 5.50008 9.28472 5.52091 8.9375 5.56258C8.59028 5.60425 8.25 5.67369 7.91667 5.77091L6.70833 4.56258C7.23611 4.35425 7.77431 4.20841 8.32292 4.12508C8.87153 4.04175 9.43056 4.00008 10 4.00008C11.9861 4.00008 13.8021 4.53828 15.4479 5.61466C17.0938 6.69105 18.2778 8.15286 19 10.0001C18.6944 10.7917 18.2882 11.5105 17.7813 12.1563C17.2743 12.8022 16.6944 13.389 16.0417 13.9167ZM16 18.1251L13.2917 15.4167C12.7639 15.6112 12.2257 15.757 11.6771 15.8542C11.1285 15.9515 10.5694 16.0001 10 16.0001C8.01389 16.0001 6.19792 15.4619 4.55208 14.3855C2.90625 13.3091 1.72222 11.8473 1 10.0001C1.30556 9.20841 1.70833 8.48619 2.20833 7.83341C2.70833 7.18064 3.29167 6.59036 3.95833 6.06258L1.875 3.97925L2.9375 2.91675L17.0625 17.0626L16 18.1251ZM5.02083 7.14591C4.53472 7.5348 4.08333 7.96189 3.66667 8.42716C3.25 8.89244 2.90972 9.41675 2.64583 10.0001C3.32639 11.4029 4.32986 12.5036 5.65625 13.3022C6.98264 14.1008 8.43056 14.5001 10 14.5001C10.3611 14.5001 10.7153 14.4758 11.0625 14.4272C11.4097 14.3786 11.7569 14.3126 12.1042 14.2292L11.1667 13.2917C10.9722 13.3612 10.7778 13.4133 10.5833 13.448C10.3889 13.4827 10.1944 13.5001 10 13.5001C9.02778 13.5001 8.20139 13.1598 7.52083 12.4792C6.84028 11.7987 6.5 10.9723 6.5 10.0001C6.5 9.80564 6.52431 9.61119 6.57292 9.41675C6.62153 9.2223 6.66667 9.02786 6.70833 8.83341L5.02083 7.14591Z"
                                        fill="#848484"/>
                                </svg>
                            </div>
                        </div>
                        <div class="sign-container">
                            <div class="sign-container-title">{{ __('Повторите пароль') }}</div>
                            <div class="sign-input-wrapper">
                                <input :type="isPasswordVisible ? 'text' : 'password'" v-model="repeatPassword"
                                       class="sign-input" placeholder="Повторите пароль" autocorrect="off"
                                       autocapitalize="off" spellcheck="false"/>
                                <svg v-if="!this.isPasswordVisible" class="visibleIcon"
                                     @click="togglePasswordVisibility" width="20" height="20" viewBox="0 0 20 20"
                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.32031 11.2577C1.82031 10.4989 1.82031 9.49997 2.32031 8.74108C3.45142 7.02664 5.94476 4.16553 10.0003 4.16553C14.0559 4.16553 16.5503 7.02553 17.6803 8.74108C18.1803 9.49997 18.1803 10.4989 17.6803 11.2577C16.5492 12.9722 14.0559 15.8333 10.0003 15.8333C5.94476 15.8333 3.45031 12.9733 2.32031 11.2577Z"
                                        stroke="#848484" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                    <path
                                        d="M9.99989 13.0554C11.6874 13.0554 13.0554 11.6874 13.0554 9.99989C13.0554 8.31235 11.6874 6.94434 9.99989 6.94434C8.31235 6.94434 6.94434 8.31235 6.94434 9.99989C6.94434 11.6874 8.31235 13.0554 9.99989 13.0554Z"
                                        stroke="#848484" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                </svg>
                                <svg v-if="this.isPasswordVisible" class="visibleIcon" @click="togglePasswordVisibility"
                                     width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.2708 11.1459L11.9792 9.85425C12.0347 9.32647 11.875 8.87161 11.5 8.48966C11.125 8.10772 10.6736 7.94453 10.1458 8.00008L8.85417 6.70841C9.03472 6.63897 9.22222 6.58689 9.41667 6.55216C9.61111 6.51744 9.80556 6.50008 10 6.50008C10.9722 6.50008 11.7986 6.84036 12.4792 7.52091C13.1597 8.20147 13.5 9.02786 13.5 10.0001C13.5 10.1945 13.4826 10.389 13.4479 10.5834C13.4132 10.7779 13.3542 10.9654 13.2708 11.1459ZM16.0417 13.9167L14.9583 12.8334C15.4583 12.4445 15.9132 12.0174 16.3229 11.5522C16.7326 11.0869 17.0764 10.5695 17.3542 10.0001C16.6736 8.5973 15.6701 7.49661 14.3438 6.698C13.0174 5.89939 11.5694 5.50008 10 5.50008C9.63889 5.50008 9.28472 5.52091 8.9375 5.56258C8.59028 5.60425 8.25 5.67369 7.91667 5.77091L6.70833 4.56258C7.23611 4.35425 7.77431 4.20841 8.32292 4.12508C8.87153 4.04175 9.43056 4.00008 10 4.00008C11.9861 4.00008 13.8021 4.53828 15.4479 5.61466C17.0938 6.69105 18.2778 8.15286 19 10.0001C18.6944 10.7917 18.2882 11.5105 17.7813 12.1563C17.2743 12.8022 16.6944 13.389 16.0417 13.9167ZM16 18.1251L13.2917 15.4167C12.7639 15.6112 12.2257 15.757 11.6771 15.8542C11.1285 15.9515 10.5694 16.0001 10 16.0001C8.01389 16.0001 6.19792 15.4619 4.55208 14.3855C2.90625 13.3091 1.72222 11.8473 1 10.0001C1.30556 9.20841 1.70833 8.48619 2.20833 7.83341C2.70833 7.18064 3.29167 6.59036 3.95833 6.06258L1.875 3.97925L2.9375 2.91675L17.0625 17.0626L16 18.1251ZM5.02083 7.14591C4.53472 7.5348 4.08333 7.96189 3.66667 8.42716C3.25 8.89244 2.90972 9.41675 2.64583 10.0001C3.32639 11.4029 4.32986 12.5036 5.65625 13.3022C6.98264 14.1008 8.43056 14.5001 10 14.5001C10.3611 14.5001 10.7153 14.4758 11.0625 14.4272C11.4097 14.3786 11.7569 14.3126 12.1042 14.2292L11.1667 13.2917C10.9722 13.3612 10.7778 13.4133 10.5833 13.448C10.3889 13.4827 10.1944 13.5001 10 13.5001C9.02778 13.5001 8.20139 13.1598 7.52083 12.4792C6.84028 11.7987 6.5 10.9723 6.5 10.0001C6.5 9.80564 6.52431 9.61119 6.57292 9.41675C6.62153 9.2223 6.66667 9.02786 6.70833 8.83341L5.02083 7.14591Z"
                                        fill="#848484"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider">
                    <div class="divider-line"></div>
                    <div class="divider-text">{{ __('или') }}</div>
                    <div class="divider-line"></div>
                </div>
                <div class="social-container">
                    <div class="discord-login" @click="onClickDiscord">
                        <svg class="social-icon" width="33" height="32" viewBox="0 0 33 32" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M24.807 8.21806C23.287 7.49492 21.6412 6.97006 19.9269 6.6668C19.9119 6.66631 19.8969 6.66919 19.8831 6.67524C19.8693 6.68128 19.8569 6.69035 19.8469 6.70179C19.6412 7.08669 19.4012 7.58823 19.2412 7.97313C17.4228 7.6932 15.5736 7.6932 13.7553 7.97313C13.5953 7.57656 13.3553 7.08669 13.1381 6.70179C13.1267 6.67847 13.0924 6.6668 13.0581 6.6668C11.3438 6.97006 9.70947 7.49492 8.178 8.21806C8.16657 8.21806 8.15515 8.22973 8.14372 8.24139C5.03506 12.9885 4.17789 17.6073 4.60076 22.1794C4.60076 22.2027 4.61219 22.2261 4.63505 22.2377C6.69225 23.7773 8.66945 24.7104 10.6238 25.3286C10.6581 25.3402 10.6924 25.3286 10.7038 25.3053C11.1609 24.6638 11.5724 23.9873 11.9267 23.2758C11.9495 23.2291 11.9267 23.1825 11.881 23.1708C11.2295 22.9142 10.6124 22.611 10.0066 22.2611C9.96091 22.2377 9.96091 22.1677 9.9952 22.1328C10.1209 22.0394 10.2466 21.9345 10.3723 21.8412C10.3952 21.8178 10.4295 21.8178 10.4524 21.8295C14.3839 23.6607 18.624 23.6607 22.5098 21.8295C22.5327 21.8178 22.567 21.8178 22.5898 21.8412C22.7155 21.9461 22.8413 22.0394 22.967 22.1444C23.0127 22.1794 23.0127 22.2494 22.9556 22.2727C22.3612 22.6343 21.7327 22.9259 21.0812 23.1825C21.0355 23.1941 21.0241 23.2525 21.0355 23.2875C21.4012 23.9989 21.8127 24.6754 22.2584 25.3169C22.2927 25.3286 22.327 25.3402 22.3612 25.3286C24.327 24.7104 26.3042 23.7773 28.3614 22.2377C28.3843 22.2261 28.3957 22.2027 28.3957 22.1794C28.8986 16.8958 27.5614 12.312 24.8527 8.24139C24.8413 8.22973 24.8299 8.21806 24.807 8.21806ZM12.521 19.3918C11.3438 19.3918 10.3609 18.2838 10.3609 16.9191C10.3609 15.5545 11.3209 14.4464 12.521 14.4464C13.7324 14.4464 14.6925 15.5661 14.681 16.9191C14.681 18.2838 13.721 19.3918 12.521 19.3918ZM20.4869 19.3918C19.3097 19.3918 18.3269 18.2838 18.3269 16.9191C18.3269 15.5545 19.2869 14.4464 20.4869 14.4464C21.6984 14.4464 22.6584 15.5661 22.647 16.9191C22.647 18.2838 21.6984 19.3918 20.4869 19.3918Z"
                                fill="white"/>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="sign-button-container">
                <div class="sign-button" @click="submit">
                    <SpinLoader v-if="loading"/>
                    <template v-else>{{ __('Создать аккаунт') }}</template>
                </div>
                <div class="sign-help">{{ __('Уже есть аккаунт?') }} <span class="sign-help-grey"
                                                                       @click="goToAuth">{{ __('Авторизация') }}</span>
                </div>
            </div>
        </div>
        <div class="sign-decoration">
            <img class="app-image" src="@/assets/images/sign/app1244.png">
        </div>
    </section>
</template>

<style scoped>
.sign {
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(255, 255, 255, 0.10) 100%), #040404;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    background-repeat: no-repeat;
    background-position: center;
    user-select: none;
}

.sign-box {
    display: flex;
    flex-direction: column;

    background: #090909;
}

.sign-input-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;

    border: 1px solid rgba(255, 255, 255, 0.05);
    background: var(--bg-accent);
}

.sign-input {
    font-family: 'TT Interfaces', sans-serif;
    font-weight: 600;

    width: 100%;
}

.sign-title {
    font-weight: 700;
    color: #FFF;
}

.sign-container {
    display: flex;
    flex-direction: column;
}

.sign-container-title {
    font-weight: 600;
    color: var(--text-accent);
}

.sign-down-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;

    background: #151515;
}

.checkbox:hover {
    cursor: pointer;
    background: #252424;
}

.checkbox-container:hover {
    cursor: pointer;
}

.checkbox-title {
    color: #A9A9A9;
    font-weight: 600;
}

.forgot {
    color: #FFF;
    transition: 0.2s ease;
}

.forgot:hover {
    cursor: pointer;
    color: var(--text-accent);
}

.divider {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.divider-line {
    background: #323030;
    height: 1px;
    flex-grow: 1;
}

.divider-text {
    font-weight: 600;
    text-align: center;
    color: var(--text-secondary);
}

.social-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
}

.tg-login, .discord-login, .google-login, .yandex-login {
    display: flex;
    align-items: center;
    justify-content: center;

    transition: 0.25s ease;
}

.tg-login:hover, .discord-login:hover, .google-login:hover, .yandex-login:hover {
    cursor: pointer;
}

.tg-login {
    background: #2AABEE;
}

.discord-login {
    background: #5865F2;
}

.google-login {
    background: #FFF;
}

.yandex-login {
    background: #F8604A;
}

.tg-login:hover {
    background: #49A1CF;
}

.discord-login:hover {
    background: #3A49E2;
}

.google-login:hover {
    background: #DEDDDD;
}

.yandex-login:hover {
    background: #FF3E22;
}

.sign-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-main);

    transition: 0.2s ease;
}

.sign-button:hover {
    cursor: pointer;
    background: #6143CE;
}

.sign-help {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    color: var(--text-secondary);

    font-weight: 600;
}

.sign-help-grey {
    color: var(--text-primary);
    transition: 0.2s ease;
}

.sign-help-grey:hover {
    cursor: pointer;
    color: var(--text-accent);
}

.sign-button-container {
    display: flex;
    flex-direction: column;
}

.sign-inputs-container {
    display: flex;
    flex-direction: column;
}

.sign-all-container {
    display: flex;
    flex-direction: column;
}

.sign-inputs-and-login-container {
    display: flex;
    flex-direction: column;
}

.sign-decoration {
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (min-width: 320px) {
    .sign {
        height: 900px;
    }

    .sign-title {
        font-size: 18px;
    }

    .sign-container-title {
        font-size: 16px;
    }

    .sign-container {
        gap: 12px;
    }

    .sign-box {
        padding: 36px 42px 24px 42px;
        border-radius: 24px;
        gap: 24px;
    }

    .sign-input {
        width: 100%;
        font-size: 15px;
        color: var(--text-accent);
    }

    .sign-input-wrapper {
        width: 300px;
        height: 40px;
        border-radius: 8px;
        padding: 16px;
        font-size: 18px;

        color: var(--text-accent);

        padding: 16px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);
    }

    .checkbox-container {
        gap: 8px;
    }

    .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .checkbox-title {
        font-size: 13px;
    }

    .forgot {
        font-size: 13px;
    }

    .divider {
        gap: 8px;
    }

    .divider-text {
        font-size: 16px;
    }

    .social-container {
        gap: 10px;
    }

    .tg-login, .discord-login, .google-login, .yandex-login {
        width: 100%;
        height: 32px;
        border-radius: 8px;
    }

    .sign-button {
        width: 300px;
        height: 38px;
        border-radius: 8px;
    }

    .sign-help {
        font-size: 14px;
        gap: 3px;
    }

    .sign-button-container {
        gap: 12px;
    }

    .sign-inputs-container {
        gap: 16px;
    }

    .sign-all-container {
        gap: 20px;
    }

    .sign-inputs-and-login-container {
        gap: 16px;
    }

    .sign-decoration {
        display: none;
    }

    .social-icon {
        height: 18px;
    }
}

@media (min-width: 464px) {
    .sign {
        height: 900px;
    }

    .sign-title {
        font-size: 20px;
    }

    .sign-container-title {
        font-size: 16px;
    }

    .sign-container {
        gap: 12px;
    }

    .sign-box {
        padding: 32px 28px 24px 28px;
        border-radius: 24px;
        gap: 24px;
    }

    .sign-input {
        width: 100%;
        color: var(--text-accent);
    }

    .sign-input-wrapper {
        width: 320px;
        height: 46px;
        border-radius: 8px;
        padding: 16px;
        font-size: 16px;

        color: var(--text-accent);

        padding: 16px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);
    }

    .checkbox-container {
        gap: 8px;
    }

    .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .checkbox-title {
        font-size: 16px;
    }

    .forgot {
        font-size: 16px;
    }

    .divider {
        gap: 8px;
    }

    .divider-text {
        font-size: 16px;
    }

    .social-container {
        gap: 10px;
    }

    .tg-login, .discord-login, .google-login, .yandex-login {
        width: 100%;
        height: 37px;
        border-radius: 8px;
    }

    .sign-button {
        width: 320px;
        height: 44px;
        border-radius: 8px;
    }

    .sign-help {
        font-size: 14px;
        gap: 3px;
    }

    .sign-button-container {
        gap: 12px;
    }

    .sign-inputs-container {
        gap: 16px;
    }

    .sign-all-container {
        gap: 20px;
    }

    .sign-inputs-and-login-container {
        gap: 16px;
    }

    .sign-decoration {
        display: none;
    }

    .social-icon {
        height: 24px;
    }
}

.visibleIcon:hover {
    cursor: pointer;
}

@media (min-width: 744px) {
    .sign {
        height: 1000px;
    }

    .sign-title {
        font-size: 20px;
    }

    .sign-container-title {
        font-size: 16px;
    }

    .sign-container {
        gap: 12px;
    }

    .sign-box {
        padding: 32px 28px 24px 28px;
        border-radius: 24px;
        gap: 24px;
    }

    .sign-input {
        width: 100%;
        color: var(--text-accent);
    }

    .sign-input-wrapper {
        width: 320px;
        height: 46px;
        border-radius: 8px;
        padding: 16px;
        font-size: 16px;

        color: var(--text-accent);

        padding: 16px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);
    }

    .checkbox-container {
        gap: 8px;
    }

    .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .checkbox-title {
        font-size: 16px;
    }

    .forgot {
        font-size: 16px;
    }

    .divider {
        gap: 8px;
    }

    .divider-text {
        font-size: 16px;
    }

    .social-container {
        gap: 10px;
    }

    .tg-login, .discord-login, .google-login, .yandex-login {
        width: 100%;
        height: 37px;
        border-radius: 8px;
    }

    .sign-button {
        width: 320px;
        height: 44px;
        border-radius: 8px;
    }

    .sign-help {
        font-size: 16px;
        gap: 3px;
    }

    .sign-button-container {
        gap: 12px;
    }

    .sign-inputs-container {
        gap: 16px;
    }

    .sign-all-container {
        gap: 20px;
    }

    .sign-inputs-and-login-container {
        gap: 16px;
    }

    .sign-decoration {
        display: flex;
        width: 366px;
        height: 60%;
        background-image: url("@/assets/images/sign/decoration1244.png");
        border-radius: 24px;
    }

    .app-image {
        height: 220px;
    }

    .social-icon {
        height: 24px;
    }
}

@media (min-width: 984px) {
    .sign {
        height: 943px;
    }

    .sign-title {
        font-size: 20px;
    }

    .sign-container-title {
        font-size: 16px;
    }

    .sign-container {
        gap: 12px;
    }

    .sign-box {
        padding: 32px 28px 24px 28px;
        border-radius: 24px;
        gap: 24px;
    }

    .sign-input {
        width: 100%;
        color: var(--text-accent);
    }

    .sign-input-wrapper {
        width: 410px;
        height: 46px;
        border-radius: 8px;
        padding: 16px;
        font-size: 16px;

        color: var(--text-accent);

        padding: 16px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);
    }

    .checkbox-container {
        gap: 8px;
    }

    .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .checkbox-title {
        font-size: 16px;
    }

    .forgot {
        font-size: 16px;
    }

    .divider {
        gap: 8px;
    }

    .divider-text {
        font-size: 16px;
    }

    .social-container {
        gap: 10px;
    }

    .tg-login, .discord-login, .google-login, .yandex-login {
        width: 100%;
        height: 44px;
        border-radius: 8px;
    }

    .sign-button {
        width: 410px;
        height: 44px;
        border-radius: 8px;
    }

    .sign-help {
        font-size: 16px;
        gap: 3px;
    }

    .sign-button-container {
        gap: 12px;
    }

    .sign-inputs-container {
        gap: 16px;
    }

    .sign-all-container {
        gap: 20px;
    }

    .sign-inputs-and-login-container {
        gap: 16px;
    }

    .sign-decoration {
        width: 518px;
        height: 65%;
        background-image: url("@/assets/images/sign/decoration1244.png");
        border-radius: 24px;
    }

    .app-image {
        height: 302px;
    }

    .social-icon {
        height: 32px;
    }
}

@media (min-width: 1248px) {
    .sign {
        height: 943px;
    }

    .sign-title {
        font-size: 20px;
    }

    .sign-container-title {
        font-size: 16px;
    }

    .sign-container {
        gap: 12px;
    }

    .sign-box {
        padding: 32px 28px 24px 28px;
        border-radius: 24px;
        gap: 24px;
    }

    .sign-input {
        width: 100%;
        height: 100%;
        color: var(--text-accent);
    }

    .sign-input-wrapper {
        width: 410px;
        height: 46px;
        border-radius: 8px;
        padding: 16px;
        font-size: 16px;

        color: var(--text-accent);

        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);

        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .checkbox-container {
        gap: 8px;
    }

    .checkbox {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .checkbox-title {
        font-size: 16px;
    }

    .forgot {
        font-size: 16px;
    }

    .divider {
        gap: 8px;
    }

    .divider-text {
        font-size: 16px;
    }

    .social-container {
        gap: 10px;
    }

    .tg-login, .discord-login, .google-login, .yandex-login {
        width: 100%;
        height: 44px;
        border-radius: 8px;
    }

    .sign-button {
        width: 410px;
        height: 44px;
        border-radius: 8px;
    }

    .sign-help {
        font-size: 16px;
        gap: 3px;
    }

    .sign-button-container {
        gap: 12px;
    }

    .sign-inputs-container {
        gap: 16px;
    }

    .sign-all-container {
        gap: 20px;
    }

    .sign-inputs-and-login-container {
        gap: 16px;
    }

    .sign-decoration {
        width: 782px;
        height: 70%;
        background-image: url("@/assets/images/sign/decoration1244.png");
        border-radius: 24px;
    }

    .app-image {
        height: 414px;
    }

    .social-icon {
        height: 32px;
    }
}

</style>